module.exports = __webpack_public_path__ + "static/proprietarios-fabefd56d06408cde89318d09ae4d89b.png";